export function isImgType(mediaItem) {
    return mediaItem.typename === 'image';
}
